import {postJSON} from '../../api/myaxios'
import {click_event} from './analysis'
// export function submit(lottery_award, submit_info) {
export function submit(award_info, submit_info) {
  const record_id = award_info.record_id;
  return postJSON('//vipact3.api.mgtv.com/api/v1/act/uinfo/add', {
    ticket: window.$bus.user.ticket,
    act_name:  award_info.act_id || award_info.lot_act_id || window.rootdata.act_name, //领取用的lot_act_id，抽奖就传目前act_name
    phase: record_id
  }, {'info': submit_info}).then(res => {
    if (res) {
      if (res.ret === 0) {
        window.$toast('提交成功');
        setTimeout(()=>{
          click_event('提交成功')
        },0);
        return 'success'
      }else if(res.ret == 314){
        window.$toast('该身份证号码已登记');
        setTimeout(()=>{
          click_event('提交失败,该身份证号码已登记')
        },0);
        return 'fail';
      } 
      else {
        const error_msg = res.msg || '提交失败';
        window.$toast(error_msg);
        setTimeout(()=>{
          click_event('提交失败')
        },0);
        return 'fail';
      }
    } else {
      setTimeout(()=>{
        click_event('提交异常')
      },0);
      throw new Error('exception');

    }
  })
}
